var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 67.733 67.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-5.197 5.67H23.157V26.950000000000003H-5.197z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.197 9.449H11.812000000000001V35.246H5.197z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    stroke: "none",
    strokeDasharray: "none",
    strokeDashoffset: 37.795,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 3,
    d: "M19.114 39.826a1.289 1.289 0 00-.904.37l-6.181 6.1a1.289 1.289 0 00-.383.931v19.056h44.442V47.227a1.289 1.289 0 00-.383-.932l-6.181-6.098a1.289 1.289 0 00-.905-.371H33.845zm.529 2.577H48.09l4.888 4.824h-9.356a10.016 10.016 0 01-9.756 7.749 10.016 10.016 0 01-9.756-7.749h-9.357z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.282,
    transform: "matrix(.77984 0 0 .77984 7.456 -6.776)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 1,
    strokeDashoffset: 37.795,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.969,
    transform: "translate(.605 3.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.715 48.938c-4.979.798-8.215 1.42-8.215 1.42v150.355s28.334-5.356 51.607-5.356c23.272 0 51.6 9.648 51.606 9.649h.002c.006-.001 28.334-9.649 51.605-9.649 23.274 0 51.608 5.356 51.608 5.356V50.357s-3.236-.62-8.215-1.42V188.74s-26.078-4.931-47.5-4.931c-21.42 0-47.493 9.223-47.498 9.224h-.002s-26.079-9.224-47.498-9.224c-21.422 0-47.5 4.931-47.5 4.931z",
    transform: "scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.215 31.785c-20.05 0-45.715 4.412-45.715 4.412V180s26.548-4.412 45.715-4.412c19.167 0 42.5 7.983 42.5 7.983s23.333-7.983 42.5-7.983S213.928 180 213.928 180V36.197s-25.664-4.412-45.713-4.412c-20.05 0-42.5 7.984-42.5 7.984s-22.451-7.984-42.5-7.984z",
    transform: "scale(.26458)"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeDasharray: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeMiterlimit: 4,
    strokeOpacity: 1,
    strokeWidth: 2,
    transform: "translate(-.01)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.086 40.358l5.211-6.548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.802 45.431l7.788-3.064"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 67.752 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.086 40.358l5.211-6.548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.802 45.431l7.788-3.064"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.26db986196e7f92c5aa1d0d410b43683.svg";
export { ForwardRef as ReactComponent };